/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import $ from 'jquery';

const DEFAULT_PLUGIN_ID = 'com.ibm.bi.explore.thumbnailBtn';
const BADGE_NOTIFICATION_CLASS = 'card-notification';
const BADGE_NOTIFICATION_SELECTOR = `.${BADGE_NOTIFICATION_CLASS}`;

import './CardNotification.scss';

class CardNotificationController {
	constructor({ glassContext, pluginId = DEFAULT_PLUGIN_ID }) {
		this.glassContext = glassContext;
		this.pluginId = pluginId;
	}

	findGlassPlugin() {
		return this.glassContext.appController.findPlugin(this.pluginId);
	}

	findNotificationContainer() {
		const plugin = this.findGlassPlugin();
		if (!plugin) {
			return;
		}

		const $el = plugin.$el;
		if (!$el) {
			return;
		}

		return $el;
	}

	makeBadge() {
		return $(`<div class="${BADGE_NOTIFICATION_CLASS}"></div>`);
	}

	activate() {
		const $container = this.findNotificationContainer();
		if (!$container) {
			return;
		}

		const $badge = $container.find(BADGE_NOTIFICATION_SELECTOR);
		if ($badge.length === 0) {
			$container.append(this.makeBadge());
		}
	}

	deactivate() {
		const $container = this.findNotificationContainer();
		if (!$container) {
			return;
		}

		$container.find(BADGE_NOTIFICATION_SELECTOR).remove();
	}
}


export default CardNotificationController;



// WEBPACK FOOTER //
// ./src/js/glass/notification/CardNotificationController.js